var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKingBedSolid = function SvgKingBedSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    fillRule: "evenodd",
    d: "M19.6 7v3.4h.4a1.6 1.6 0 0 1 1.6 1.6v4.6h-1.2L20 19h-1l-.4-2.4H5.4L5 19H4l-.4-2.4H2.4V12A1.6 1.6 0 0 1 4 10.4h.4V7A1.6 1.6 0 0 1 6 5.4h12A1.6 1.6 0 0 1 19.6 7Z",
    clipRule: "evenodd"
  })));
};
export default SvgKingBedSolid;